module.exports = __webpack_public_path__ + "img/1500137124.9dbd5d11.jpg";